import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { IconName } from '@fortawesome/free-solid-svg-icons';
import { ClashListDto } from '@models/clash/clashes/clash-list-dto';
import { ScoreInputForm } from '@models/clash/scoreboard/score-input-form';
import { SportTournamentTemplateDto } from '@models/clash/SportTorneioTemplate/sport-tournament-template-dto';
import { ICompleteStepParameterizationDto } from '@models/competition/step-paramaterization/dtos/complete-simple-step-parameterization-dto';
import { MetadataPutEnum } from '@models/enums/metadata-put-enum';
import { IPage } from '@models/pagination/page';
import { ClashRegistrationService } from '@shared/services/competition/clash-registration/clash-registration.service';
import { ScoreboardService } from '@shared/services/competition/scoreboard/scoreboard.service';
import { SportTorneioTemplateService } from '@shared/services/competition/SportTorneioTemplate/sport-torneio-template.service';
import { StepParameterizationService } from '@shared/services/competition/step-parametrization.service';
import { switchMap } from 'rxjs';
import { BaseComponent } from 'src/app/core/utilities/base-component/base-component';
import { ScoredboardDto } from './../../../../../models/clash/scoreboard/scoreboard-dto';
import { ScoredboardForm } from './../../../../../models/clash/scoreboard/scoreboard-form';
@Component({
  selector: 'sigecom-scoreboard',
  templateUrl: './scoreboard.component.html',
})
export class ScoreboardComponent extends BaseComponent implements OnInit {
  @Input() teams!: ClashListDto;
  @Input() cheNrId!: number;
  @Output() closeModalScoreboard = new EventEmitter<void>();
  @Input() invertIconPos = false;
  @Input() enableLoading: boolean = false;
  @Input() icon?: IconName;

  readonly #scoreboardService = inject(ScoreboardService);
  readonly #sportTorneioTemplateService = inject(SportTorneioTemplateService);
  readonly #stepParametrizationService = inject(StepParameterizationService);
  readonly #clashService = inject(ClashRegistrationService);
  readonly cdr = inject(ChangeDetectorRef);

  scoredboardDto!: IPage<ScoredboardDto>;
  scoredboardForm!: ScoreInputForm;
  sportTournamentTemplateDto!: SportTournamentTemplateDto;
  iCompleteStepParameterizationDto?: ICompleteStepParameterizationDto;

  editingIndex?: number = undefined;
  periodName?: string;
  embBlResultadoDefinido = false;
  @Input() petNrId?: number;
  ettNrQtdPeriodo: number = 1;

  inputs = new Map<string, number>();
  sets = Array.from({ length: 2 }, (_, i) => i);

  ngOnInit(): void {
    this.scoredboardForm = {
      placarForms: [],
    };
    this.sets = [];
    console.log(this.teams);
    this.#getStepParametrizationById();
    this.#listScoreOfAFight();
  }
  #genereateScoreboardForm() {
    this.scoredboardForm.placarForms = [];
    this.sets = [];
    let scoreboardForm: ScoredboardForm;
    for (let i = 0; i < this.sportTournamentTemplateDto.ettNrQtdPeriodo; i++) {
      this.teams.embListInscricaoDto.forEach((item) => {
        scoreboardForm = {
          plaNrPeriodo: i + 1,
          plaNrPlacar: 0,
          plaTxPeriodo: `${this.periodName} ${i + 1}`,
          iemNrId: item.iemNrId,
          entTxMetadado: MetadataPutEnum.CRIADO,
        };
        this.scoredboardForm.placarForms.push(scoreboardForm);
      });
      this.sets.push(i + 1);
    }
  }

  #searchSportsTournamentsTemplatesById(ettNrId: number) {
    this.#sportTorneioTemplateService
      .searchSportsTournamentsTemplatesById(ettNrId)
      .subscribe({
        next: (res) => {
          this.sportTournamentTemplateDto = res.response;
          let maior = res.response.ettNrQtdPeriodo;
          this.ettNrQtdPeriodo = maior;
          if (this.scoredboardDto?.content) {
            this.scoredboardDto.content.forEach((item) => {
              maior = item.incListPlacar.length;
              if (maior < item.incListPlacar.length) {
                maior = item.incListPlacar.length;
              }
            });
          }
          this.sets = Array.from({ length: maior }, (_, i) => i);
          this.periodName = res.response.ettTxNomePeriodo;
          if (this.scoredboardDto.empty) {
            this.#genereateScoreboardForm();
          }
        },
        error: (error) => this.messageErrorResolver.resolveMessage(error),
      });
  }

  #getStepParametrizationById() {
    const petNrId = this.petNrId;

    this.#stepParametrizationService
      .getStepParametrizationById$(petNrId!)
      .subscribe({
        next: (res) => {
          this.petNrId = res.petNrId;
          this.iCompleteStepParameterizationDto = res;
          this.#searchSportsTournamentsTemplatesById(res.ettNrId!);
        },
        error: (error) => this.messageErrorResolver.resolveMessage(error),
      });
  }

  declareWOInAPeriod(iemNrId: number) {
    let vencedor = false;

    if (this.iCompleteStepParameterizationDto!.petBlEmbDireto) {
      this.teams.embListInscricaoDto?.forEach((item) => {
        if (iemNrId != item.iemNrId) {
          vencedor = true;
        }

        this.#scoreboardService
          .declareWOInAPeriod(item.iemNrId!, vencedor)
          .subscribe({
            next: () => {},
            error: (error) => this.messageErrorResolver.resolveMessage(error),
          });
      });

      this.snackbarService.showSuccess('Resultado por W.O. atribuído.');
      this.outputCloseModalScoreboard();
    } else {
      this.snackbarService.showWarn(
        'Resultado por W.O para embates diferentes de diretos nao foram implementados.',
      );
    }
  }

  getSetsVencidosPorParticipante(incNrId: number): number {
    let setsVencidos = 0;

    if (!this.scoredboardDto?.content) {
      return setsVencidos;
    }

    // Para cada período
    for (let periodo of this.sets) {
      let placaresDoPeriodo = this.scoredboardDto.content.map(
        (participante) => ({
          incNrId: participante.incNrId,
          placar:
            participante.incListPlacar.find(
              (p) => p.plaNrPeriodo === periodo + 1,
            )?.plaNrPlacar || 0,
        }),
      );

      // Ordena por maior placar
      placaresDoPeriodo.sort((a, b) => b.placar - a.placar);

      if (
        placaresDoPeriodo.length > 1 &&
        placaresDoPeriodo[0].placar > placaresDoPeriodo[1].placar &&
        placaresDoPeriodo[0].incNrId === incNrId
      ) {
        setsVencidos++;
      }
    }

    return setsVencidos;
  }

  getVencedorDosSets(): number | null {
    if (!this.scoredboardDto?.content) return null;

    const participantes = this.scoredboardDto.content.map((p) => ({
      incNrId: p.incNrId,
      setsVencidos: this.getSetsVencidosPorParticipante(p.incNrId),
    }));

    if (participantes.length < 2) return null;

    const [a, b] = participantes;

    if (a.setsVencidos > b.setsVencidos) return a.incNrId;
    if (b.setsVencidos > a.setsVencidos) return b.incNrId;

    return null; // empate
  }

  getTotal(incNrId: number) {
    if (!this.scoredboardDto || !this.scoredboardDto.content) {
      return 0; // ou return undefined, se preferir
    }

    return this.scoredboardDto.content
      .filter((p) => p.incNrId === incNrId)
      .flatMap((p) => p.incListPlacar)
      .reduce((sum, set) => sum + (set.plaNrPlacar || 0), 0);
  }

  getPeriodName(j: number): string {
    const placarFiltrado = this.scoredboardForm.placarForms
      .filter((p) => p.plaNrPeriodo === j)
      .map((p) => p.plaTxPeriodo);
    return placarFiltrado.length > 0 && placarFiltrado[0]
      ? placarFiltrado[0]
      : `${this.periodName} ${j}`;
  }
  setPeriodName(plaNrPeriodo: number, ev: Event) {
    const input = ev.target as HTMLInputElement;
    const value = input.value;
    this.teams.embListInscricaoDto.forEach((item) => {
      const index = this.scoredboardForm.placarForms.findIndex(
        (s) => s.plaNrPeriodo === plaNrPeriodo && s.iemNrId == item.iemNrId,
      );
      if (index != -1) {
        this.scoredboardForm.placarForms[index].plaTxPeriodo = value;
        if (
          this.scoredboardDto.content &&
          this.scoredboardDto.content[index] != undefined
        ) {
          this.scoredboardForm.placarForms[index].entTxMetadado =
            MetadataPutEnum.ALTERADO;
        } else
          this.scoredboardForm.placarForms[index].entTxMetadado =
            MetadataPutEnum.CRIADO;
      } else {
        console.log(plaNrPeriodo + ' not found');
      }
    });
  }
  enableNameEdit(i: number) {
    this.editingIndex = i;
  }
  disableNameEdit(): void {
    this.editingIndex = undefined;
  }

  adicionarSet() {
    this.sets.push(this.sets.length);
    const novoPeriodo = this.sets.length;
    let scoreboardForm: ScoredboardForm;
    this.teams.embListInscricaoDto.forEach((item) => {
      scoreboardForm = {
        plaNrPeriodo: novoPeriodo,
        plaNrPlacar: 0,
        plaTxPeriodo: `${this.periodName} ${novoPeriodo}`,
        iemNrId: item.iemNrId,
        entTxMetadado: MetadataPutEnum.CRIADO,
      };
      this.scoredboardForm.placarForms.push(scoreboardForm);
    });
  }

  #listScoreOfAFight() {
    this.#scoreboardService
      .listScoreOfAFight(this.teams.embNrId!, { page: 0, size: 100 })
      .subscribe({
        next: (res) => {
          this.scoredboardDto = res.response;

          let length = !this.scoredboardDto.empty
            ? this.scoredboardDto.content![0].incListPlacar.length
            : this.sportTournamentTemplateDto.ettNrQtdPeriodo;

          this.sets = Array.from({ length: length }, (_, i) => i);
          this.scoredboardForm = {
            ...this.scoredboardForm, // se houver outros campos em FormBase
            placarForms: this.scoredboardDto.content!.flatMap((item) =>
              item.incListPlacar.map((placar) => ({
                plaNrId: placar.plaNrId,
                entNrId: placar.plaNrId,
                plaNrPlacar: placar.plaNrPlacar!,
                plaNrPeriodo: placar.plaNrPeriodo,
                plaTxPeriodo: placar.plaTxPeriodo,
                iemNrId: item.iemNrId,
                entTxMetadado: MetadataPutEnum.INALTERADO,
              })),
            ),
          };
        },
      });
  }

  getTotalDeSetsReais(): number {
    const placares = this.scoredboardForm.placarForms;

    // Mapa para armazenar os períodos únicos por jogador
    const periodosPorJogador = new Map<number, Set<number>>();

    placares.forEach((p) => {
      if (!periodosPorJogador.has(p.iemNrId!)) {
        periodosPorJogador.set(p.iemNrId!, new Set<number>());
      }
      periodosPorJogador.get(p.iemNrId!)!.add(p.plaNrPeriodo!);
    });

    // Retorna o maior número de períodos distintos entre os jogadores
    return Math.max(
      ...Array.from(periodosPorJogador.values()).map((set) => set.size),
    );
  }

  #registerScoreOfAPeriod() {
    this.#scoreboardService
      .registerScoreOfAPeriod(this.scoredboardForm)
      .pipe(
        switchMap(() => {
          return this.#clashService.clashConcluded(
            this.teams.embNrId!,
            this.embBlResultadoDefinido,
          );
        }),
      )
      .subscribe({
        next: () => {
          this.snackbarService.showSuccess('Placar adicionado com sucesso!');
          this.outputCloseModalScoreboard();
        },
        error: (error) => this.messageErrorResolver.resolveMessage(error),
        complete: () => (this.enableLoading = false),
      });
  }

  outputCloseModalScoreboard() {
    this.closeModalScoreboard.emit();
  }

  submit() {
    this.enableLoading = true;

    this.scoredboardForm.petNrId = this.petNrId;
    if (!this.scoredboardDto.empty) {
      this.scoredboardForm.entTxMetadado = MetadataPutEnum.ALTERADO;
    } else {
      this.scoredboardForm.entTxMetadado = MetadataPutEnum.CRIADO;
      this.scoredboardForm.placarForms.forEach((item) => {
        item.entTxMetadado = MetadataPutEnum.CRIADO;
      });
    }
    this.#registerScoreOfAPeriod();
  }

  // Pega valor do Map
  getValor(iemNrId: number, j: number): number {
    if (!this.scoredboardDto || !this.scoredboardDto.content) {
      return 0;
    }
    const placarFiltrado = this.scoredboardForm.placarForms
      .filter((p) => p.iemNrId === iemNrId)
      .filter((p) => p.plaNrPeriodo === j)
      .map((p) => p.plaNrPlacar);

    return placarFiltrado.length > 0 ? placarFiltrado[0]! : 0;
  }

  resetScoreboard() {
    if (!this.scoredboardForm?.placarForms) return;
    this.#scoreboardService.resetScoreBoard(this.teams.embNrId!).subscribe({
      next: () => {
        this.#listScoreOfAFight();
        this.snackbarService.showSuccess('Placares resetados com sucesso');
      },
      error: () =>
        this.snackbarService.showDanger('Não foi possivel resetar os placares'),
    });
  }

  // Ao alterar input
  onInputChange(iemNrId: number, plaNrPeriodo: number, plaNrPlacar: number) {
    // Só inicializa se ainda for undefined
    if (!this.scoredboardForm.placarForms) {
      this.scoredboardForm.placarForms = [];
    }

    const index = this.scoredboardForm.placarForms.findIndex(
      (s) => s.iemNrId === iemNrId && s.plaNrPeriodo === plaNrPeriodo,
    );

    if (index !== -1) {
      // Já existe: atualizar
      if (!this.scoredboardDto.empty) {
        let metadado = MetadataPutEnum.CRIADO;
        if (
          this.scoredboardForm.placarForms[index].entTxMetadado !==
          MetadataPutEnum.CRIADO
        ) {
          metadado = MetadataPutEnum.ALTERADO;
        }

        this.scoredboardForm.placarForms[index].plaNrPlacar = plaNrPlacar;
        // this.scoredboardForm.placarForms[index].entNrId = index;
        this.scoredboardForm.placarForms[index].entTxMetadado = metadado;
        console.log(this.scoredboardForm);
      } else {
        this.scoredboardForm.placarForms[index].plaNrPlacar = plaNrPlacar;
      }
    } else {
      // Não existe: adicionar novo
      const scoreboard: ScoredboardForm = {
        plaNrPeriodo,
        plaNrPlacar,
        plaTxPeriodo: '',
        iemNrId: iemNrId,
        entTxMetadado: MetadataPutEnum.CRIADO,
      };
      this.scoredboardForm.placarForms.push(scoreboard);
    }
  }
  setEmbDefined(ev: boolean) {
    this.embBlResultadoDefinido = ev;
  }
  abreviate(text: string) {
    text = text.replace(/\bescola\b/gi, 'ESC');
    text = text.replace(/\bestadual\b/gi, 'EST');
    return text;
  }
}
